import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { __ } from '../../../locales';
import HandDownSvg from '../../../images/HandDownSvg';

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '75%',
    paddingBottom: 10,
    borderRadius: 15,
    border: 'none',
    padding: '40px 10px'
  }
};

const GotIt = styled.button`
  width: 85%;
  max-width: 300px;
  height: 6vh;
  justify-content: center;
  align-items: center;
  background-color: #00008B;
  color: white;
  border: none;
  border-radius: 8px;
  margin-bottom: 20px;
`;

const Header = styled.h2`
  font-size: 20px;
  text-align: center;
  margin: 0;
`;

const Context = styled.h2`
  font-size: 16px;
  text-align: center;
  font-weight: 400;
  color: #818181;
  line-height: 20px;
  margin: 16px;
`;

const TeachSwipingModal = ({
  onClose,
}) => (
  <Modal
    isOpen
    onRequestClose={onClose}
    style={customModalStyles}
    overlayClassName="signup-modal-overlay"
  >
    <Header>
      Try this
      <HandDownSvg />
    </Header>
    <Context>
      {__('app.teach_swiping')}
    </Context>

    <GotIt onClick={onClose}>
      {__('app.got_it')}

    </GotIt>
  </Modal>
);

export default TeachSwipingModal;
